/* 🤖 this file was generated by svg-to-ts */
export const matIconForest: {
  name: 'forest';
  data: string;
} = {
  name: 'forest',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m24 18-3.86-6H22L15 2l-3 4.29L9 2 2 12h1.86L0 18h7v4h4v-4h2v4h4v-4h7zM15 5.49 18.16 10h-1.68l3.86 6h-3.62l-2.57-4H16l-2.78-3.97L15 5.49zM3.66 16l3.86-6H5.84L9 5.49 12.16 10h-1.68l3.86 6H3.66z"/></svg>`
};
